export const p5SoundURLOldTemplate =
  'https://cdn.jsdelivr.net/npm/p5@$VERSION/lib/addons/p5.sound.min.js';
export const p5SoundURL =
  'https://cdn.jsdelivr.net/npm/p5.sound@0.3.0/dist/p5.sound.min.js';
export const p5PreloadAddonURL =
  'https://cdn.jsdelivr.net/npm/p5.js-compatibility@0.2.0/src/preload.js';
export const p5ShapesAddonURL =
  'https://cdn.jsdelivr.net/npm/p5.js-compatibility@0.2.0/src/shapes.js';
export const p5DataAddonURL =
  'https://cdn.jsdelivr.net/npm/p5.js-compatibility@0.2.0/src/data.js';
export const p5URLTemplate =
  'https://cdn.jsdelivr.net/npm/p5@$VERSION/lib/p5.js';
export const lilGuiURL =
  'https://cdn.jsdelivr.net/npm/lil-gui@0.19/dist/lil-gui.umd.min.js';
